import { useReducer } from "react";
import { useTranslation } from "react-i18next";
import { PageLayout } from "../../Components/PageLayout";
import { VehicleTabs } from "../../Components/Tables/Vehicles/Tabs";
import { BacklogCTPAT } from "./Tables/F15";
import { F05DriverTable } from "./Tables/F05-001";
import { F12Table } from "./Tables/F12";
import { F05EmployeeTable } from "./Tables/F05";
import F23Table from "./Tables/F23";

function getRoutePage(route) {
  switch (route) {
    case "F15":
      return "safety/ctpat-reports";
    case "F05 Conductores":
      const today = new Date().toISOString().split("T")[0];
      return `assets/all-visitors?location=Tijuana+Yard&category=Driver&date=${today}`;
    case "F12 Proveedores":
      return "assets/all-visitors?location=Tijuana+Yard&category=Visitor";
    default:
      return "";
  }
}
const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_DATA":
      return {
        ...state,
        isLoading: true,
        error: null,
        data: null,
        next: null,
        previous: null,
      };
    case "NEXT_PAGE":
      return {
        ...state,
        isLoading: true,
        currentPageNum: state.currentPageNum + 1,
        currentPage: state.next,
      };
    case "PREV_PAGE":
      return {
        ...state,
        isLoading: true,
        currentPageNum: state.currentPageNum - 1,
        currentPage: state.previous,
      };
    case "SET_DATA":
      return {
        ...state,
        isLoading: false,
        data: action.payload.results,
        next: action.payload.next,
        previous: action.payload.previous,
      };
    case "SET_CURRENT_TAB":
      return {
        ...state,
        currentRoute: action.payload,
        currentPage: getRoutePage(action.payload),
        data: null,
      };
    case "SET_CURRENT_PAGE":
      return {
        ...state,
        currentPage: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

const initialState = {
  isLoading: true,
  error: null,
  data: null,
  next: null,
  previous: null,
  currentPageNum: 1,
  currentPage: null,
  selectedRow: null,
  currentRoute: "F15/F17",
  currentPage: "safety/ctpat-reports",
};

const CTPATView = () => {
  const { t } = useTranslation();
  const [pageState, dispatch] = useReducer(reducer, initialState);

  const tabs = [
    "F15/F17",
    t("forms.type.f05.employee-header"),
    t("forms.type.f05.driver-header"),
    t("forms.type.f12.header"),
    t("forms.type.f23.header"),
  ];

  return (
    <PageLayout title={"CTPAT Reports"}>
      <div className="overview-header">
        <h1 className="global-h1 black">C-TPAT {t("page-headers.reports")}</h1>
      </div>
      <VehicleTabs
        tabs={tabs}
        selectedTab={pageState.currentRoute}
        setSelectedTab={(tab) =>
          dispatch({
            type: "SET_CURRENT_TAB",
            payload: tab,
          })
        }
      />
      {pageState.currentRoute === "F15/F17" && <BacklogCTPAT />}
      {pageState.currentRoute === t("forms.type.f05.driver-header") && (
        <F05DriverTable />
      )}
      {pageState.currentRoute === t("forms.type.f12.header") && <F12Table />}
      {pageState.currentRoute === t("forms.type.f05.employee-header") && (
        <F05EmployeeTable />
      )}
      {pageState.currentRoute === t("forms.type.f23.header") && <F23Table />}
    </PageLayout>
  );
};

export default CTPATView;
